import { Component, OnInit } from "@angular/core";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { ImageUrls } from "src/app/services/s3buket";

@Component({
  selector: "app-job-roles",
  templateUrl: "./job-roles.component.html",
  styleUrls: ["./job-roles.component.css"]
})
export class JobRolesComponent implements OnInit {

  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  jobRoleList: any = [];

  constructor(private api: AdminService) { }

  ngOnInit(): void {
    this.getJobRolesList();
  }

  getJobRolesList() {
    this.api.getData(apiUrl._jobRolesList, {}).subscribe(res => {
      this.jobRoleList = res.data.data;
    })
  }
}
